import React from "react";
import About from "./components/About/About";
import Career from "./components/Career/Career";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import Languages from "./components/Languages/Languages";
import Navigation from "./components/Navigation/Navigation";
import Project from "./components/Projects/Project";
import Summary from "./components/Summary/Summary";
import Progress from "./components/Progress/Progress";
import Theme from "./components/Theme/Theme";

const App = () => {
  return (
    <>
      <Theme />
      <Progress />
      <div className="container">
        <Navigation />
        <Home />
        <Summary />
        <Languages />
        <Project />
        <Career />
        <About />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default App;
